// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__3gbeJ","legacyBtn":"MutateMid_legacyBtn__2NhJh"};